import { post, errorvue, failed, get, success, alertvue } from '@/utils/util'
import { shadesDataStore } from "@/store/index";
import { useRouter } from 'vue-router';
import { Session } from '@/utils/AxiosToken';

import html2pdf from 'html2pdf.js'
export function getPendingList(pagesize, pageindex, listparams, callback) {
    post("Order/GetPendingOrderList", { pagesize, pageindex, listparams: listparams }).then((res) => {
        if (res.success) {
            console.log("Order/GetPendingOrderList", JSON.parse(res.resultdata.recordset));

            // console.log("GetPendingOrderList",res);
            if (res.success) {
                if (callback && callback instanceof Function) {
                    callback(res);

                }
            } else {
                failed(res.message);
            }

        } else {
            failed(res.message);
        }
    }).catch((res) => {
        errorvue(res.message || res);
        return;
    });
}
export function getCheckOutList(pagesize, pageindex, listparams, callback) {
    post("Order/TrakOrderList", { pagesize, pageindex, listparams: listparams }).then((res) => {
        if (res.success) {
            if (res.success) {
                console.log("Order/TrakOrderList", JSON.parse(res.resultdata.recordset), res);
                if (callback && callback instanceof Function) {
                    callback(res);

                }
            } else {
                failed(res.message);
            }

        } else {
            failed(res.message);
        }
    }).catch((res) => {
        errorvue(res.message || res);
        return;
    });
}
export function DeleteWholeOrder(orderid, callback) {

    if (!window.confirm("Confirm to Delete whole order?")) {
        return;
    }
    get("Order/DeleteOrder", { orderid: orderid, dt: new Date() }).then((res) => {
        if (res.success) {
            if (callback && callback instanceof Function) {
                callback("sucess");
                success("Delete whole order success.");
            }
        } else {
            failed(res.message);
        }
    }).catch((res) => {
        errorvue(res.message || res);
    });
}
export function GetProductName(pdtype) {
    switch (pdtype) { 
        case "CS":
            return "Shutter";
        case "CC":
            return "Thermacell";
        case "CB":
            return "Venetian Blinds";
        case "RL":
            return "Soluna Roller Blind";
        case "PS":
            return "PerfectSheer";
        case "SD":
            return "SmartDrape";
        case "DT":
            return "Display Tower";
        case "RM":
            return "Roman";
        case "RMBG":
            return "Roman Kit";
        case "RLBG":
            return "Roller Kit";
        case "PSBG":
            return "SmartDrape/PerfectSheer Kit";
        case "CBBG":
            return "SmartPrivacy Kit";
        case "CSBG":
            return "Shutter Kit";
        case "HSBG":
            return "Hand Kit";
        case "CCBG":
            return "Thermacell Kit";
        }
    return pdtype
}

export function GetShortProductName(pdtype) {
    switch (pdtype) { 
        case "RMBG":
            return "Roman Kit";
        case "RLBG":
            return "Roller Kit";
        case "PSBG":
            return "SmartDrape/PerfectSheer Kit";
        case "CBBG":
            return "SmartPrivacy Kit";
        case "CSBG":
            return "Shutter Kit";
        case "HSBG":
            return "Hand Kit";
        case "CCBG":
            return "Thermacell Kit";
        }
    return pdtype
}

//spec Used by sample bag 
export function GetSpecName(pdtype) {

    switch (pdtype) {
        case "RMBG":
            return "76001-00254-A";
        case "RLBG":
            return "76001-00261";
        case "PSBG":
            return "76001-00260";
        case "CBBG":
            return "76001-00171";
        case "CSBG":
            return "36102-66502";
        case "HSBG":
            return "36102-63400-A";
        case "CCBG":
            return "76001-00160-B";
    }
    return pdtype
}

//spec Used by sample bag 
export function GetProductTypeBySpec(spec) {

    switch (spec) {
        case "76001-00254-A":
            return "RMBG";
        case "76001-00261":
            return "RLBG";
        case "76001-00260":
            return "PSBG";
        case "76001-00171":
            return "CBBG";
        case "36102-66502":
            return "CSBG";
        case "36102-63400-A":
            return "HSBG";
        case "76001-00160-B":
            return "CCBG";
    }
    return pdtype
}

export function getAustraliaDay(dt) {

    if (!dt) return "-";
    try {
        if (dt.indexOf("0001") == 0) return "-";
        let date = new Date(dt);
        console.warn(dt, date.getFullYear())

        if (date.getFullYear() < 1981) return "-";

        let daydesc = "";
        if (date.getMonth() == 0) daydesc = "Jan";
        else if (date.getMonth() == 1) daydesc = "Feb";
        else if (date.getMonth() == 2) daydesc = "Mar";
        else if (date.getMonth() == 3) daydesc = "Apr";
        else if (date.getMonth() == 4) daydesc = "May";
        else if (date.getMonth() == 5) daydesc = "Jun";
        else if (date.getMonth() == 6) daydesc = "Jul";
        else if (date.getMonth() == 7) daydesc = "Aug";
        else if (date.getMonth() == 8) daydesc = "Sep";
        else if (date.getMonth() == 9) daydesc = "Oct";
        else if (date.getMonth() == 10) daydesc = "Nov";
        else if (date.getMonth() == 11) daydesc = "Dec";
        daydesc += "-" + (date.getDate() < 10 ? "0" : "") + date.getDate().toString() + "-" + date.getFullYear().toString();
        return daydesc;
    } catch {
        return dt;
    }
}
export function getStatusName(dt) {
    if (!dt) return "-";
    switch (dt) {
        case "01":
            return "Job Sent";
        case "00":
            return "Production Control";
        case "02":
            return "On Hold";
        case "03":
            return "Canceled";
        case "11":
            return "Production";
        case "18":
            return "Shipped";
        case "20":
            return "Billing";
    }
    return dt;
}

export function PriceMusk(price) {
    if (price && price < 0) return "xx.xx";
    else
        return price;
}
export function DeleteItem(orderid, line_no, producttype, callback) {
    get("Order/DeleteOrderItem", { orderid, line_no, producttype }).then((res) => {
        if (res.success) {
            if (callback && callback instanceof Function) {
                success("Delete order detail success.");
                callback("sucess");

            }

        } else {
            failed(res.message);
        }
    }).catch((res) => {
        errorvue(res.message || res);

    });
}

export function getModel(orderid, orderno, callback) {
    // console.log("GetOrderEnity", orderid, orderno);
    post("Order/GetOrderEnity", [orderid, orderno]).then((res) => {
        if (res.success == false) {
            failed(res.message);
            return;
        } else {
            if (callback && callback instanceof Function) {
                console.log("Order/GetOrderEnity", res);

                callback(res.resultdata);

            }
        }
    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message);
        }

    });
}
export function SaveHandSample(OrderPart, callback) {
    post("Order/SaveHandSample", OrderPart).then((res) => {
        if (res.success) {
            if (callback && callback instanceof Function) {
                callback("sucess");
            }

        } else {
            failed(res.message);
        }
    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message || err.statusText);
        }

    });
}
export function GetHandSampleConfig(samplecode) {
    return get("Order/GetHandSampleConfig?samplecode=" + samplecode);
    //get("Order/GetHandSampleConfig?samplecode=" + samplecode).then((res) => {
    //    if (res.success) {
    //        if (callback && callback instanceof Function) {
    //            callback(JSON.parse(res.resultdata));
    //        }
    //    } else {
    //        failed(res.message);
    //    }
    //}
    //).catch((err) => {
    //    if (err.status && err.status != 401) {
    //        errorvue(err.message || err.statusText);
    //    }

    //});
}
export function SavePart(OrderPart, callback) {
    post("Order/SavePart", OrderPart).then((res) => {
        if (res.success) {
            if (callback && callback instanceof Function) {
                callback("sucess");
            }

        } else {
            failed(res.message);
        }
    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message || err.statusText);
        }

    });
}
export function GetPartList(orderid, orderno, callback) {
    post("Order/GetPartList", [orderid, orderno]).then((res) => {

        if (callback && callback instanceof Function) {

            callback(res);
        }


    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message || err.statusText);
        }

    });
}
export function GetPart(orderid, itemno, callback) {
    get(`Order/GetPart/${orderid}/${itemno}`).then((res) => {
        if (res.success) {
            if (callback && callback instanceof Function) {
                callback(res.resultdata);
            }
        } else {
            failed(res.message);
        }

    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message || err.statusText);
        }

    });
}
export function GetDTPart(orderid, itemno, orderno, callback) {
    get(`Order/GetPart/${orderid}/${itemno}/${orderno}`).then((res) => {
        if (res.success) {
            if (callback && callback instanceof Function) {
                callback(res.resultdata);
            }
        } else {
            failed(res.message);
        }

    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message || err.statusText);
        }

    });
}
export function GetNewItemNo(orderid, producttype, callback) {
    get("Order/GetNewItemNo", { orderid: orderid, producttype: producttype }).then((res) => {
        if (res.success) {
            if (callback && callback instanceof Function) {
                callback(res.resultdata);
            }
        } else {
            errorvue(res.message);
        }
    }).catch((res) => {
        errorvue(res.message || res);
    });
}
export function CopyItem(orderid, line_no, callback) {
    get("Order/CopyOrderItem", { OrderId: orderid, Line_No: line_no }).then((res) => {
        if (res.success == false) {
            failed(res.message);
            return;
        } else {
            var rtn = JSON.parse(res.resultdata);
            console.log(rtn)
            if (rtn.rows) {

                if (callback && callback instanceof Function) {

                    callback(rtn.rows[0]);
                }
            }
            // window.location.reload();
        }
    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message || err.statusText);
        }
    });
}
export function CopyFromOrder(orderid, fromorderno, fromitem, enditem, callback) {
    get("Order/CopyFromOrder", { OrderId: orderid, fromorderno, fromitem, enditem }).then((res) => {
        if (res.success == false) {
            failed(res.message);
            return;
        } else {
            var rtn = JSON.parse(res.resultdata);

            if (rtn.rows) {
                // if (callback && callback instanceof Function) {
                if (rtn.rows.length == 1) {
                    console.log(rtn.rows)
                    if (rtn.rows[0].errmess) {
                        if (rtn.rows[0].errmess.indexOf("material") > -1) {
                            alertvue("The order number or item you enter contains discontinued material or old material's code, so it can not be copied.");
                            return;

                        } else if (rtn.rows[0].errmess.indexOf("2014BY-PASS") > -1) {
                            alertvue("In the order or item being copied contains 2014 Bypass, which is not available and therefore can't be copied.");
                            return;

                        }
                    }
                    if (callback && callback instanceof Function) {
                        callback(rtn.rows[0]);
                    } else {
                        window.location.reload();
                    }
                } else if (rtn.rows.length > 1) {
                    for (let item of rtn.rows) {
                        if (item.errmess) {
                            if (item.errmess.indexOf("material") > -1) {
                                alertvue("The order number or item you enter contains discontinued material or old material's code, so it can not be copied.");
                                return;

                            } else if (item.errmess.indexOf("2014BY-PASS") > -1) {
                                alertvue("In the order or item being copied contains 2014 Bypass, which is not available and therefore can't be copied.");
                                return;
                            }
                        }
                    }
                    window.location.reload();
                } else {
                    alertvue("No record.");
                }
                // }
            }
        }
    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message || err.statusText);
        }
    });
}
export function DuplicateOrder(orderid,from,end, callback) {
    get("Order/DuplicateOrder", { OrderId: orderid,from:from,end:end }).then((res) => {
        if (res.success == false) {
            failed(res.message);
            return;
        } else {
            if (callback && callback instanceof Function) {
                callback(res);
            } else {
                window.location.reload();
            }
        }
    }).catch((err) => {
        if (err.status && err.status != 401) {
            errorvue(err.message || err.statusText);
        }
    });
}

//TODO:
export function addProductType(orderid, lineno, producttype) {
    window.sessionStorage.setItem(orderid, lineno); //refresh data .
    let $router = useRouter();
    switch (producttype) {
        case "CS":
            $router.push({ path: "/shutters" })
            break;
        case "CC":
            $router.push({ name: 'honeycomb', params: { producttype: producttype, lastactioncode: 'New', orderid: orderid, lineno } });
            break;
        case "CB":
            $router.push({ path: "/blinds" })
            break;
        case "PS":
            $router.push({ path: "/pefectsheer" })
            break;
        case "RL":
            $router.push({ path: "/soluna" })
            break;
        case "CSBG":
            $router.push({ path: "/samplebag" })
            break;
    }
    GetNewItemNo($router.currentRoute._value.params.orderid, $router.currentRoute._value.params.producttype, (newitmno) => {
        //  addProductType(orderdatas.orderid, newitmno, orderdatas.producttype);

    });
}
export function CheckAllowCheckOut(orderid, callback) {
    get("Order/PreCheckOutCheck", { orderid: orderid }).then((res) => {

        if (res.success) {
            if (callback && callback instanceof Function) {
                callback(res.resultdata);
            }
        } else {
            errorvue(res.message);
        }
    }).catch((res) => {
        errorvue(res.message || res);
        return false;
    });
}
export function getOrderStatus(statusid) {
    switch (statusid) {
        case "00":
            return "<font color='gray'>Production Control</font>";
        case "02":
            return "<font color='red'>On Hold</font>";
        case "11":
            return "<font color='black'>Production</font>";
        case "18":
            return "<font color='blue'>Shipped</font>";
        case "03":
        case "14":
            return "<font color='gray'>Canceled</font>";
        case "20":
            return "<font color='gray'>Billing</font>";
    }
    return statusid;
}
export function CheckOutOrder(orderid, callback) {
    get("Order/CheckOut", { orderid: orderid }).then((res) => {

        if (res.success) {
            if (callback && callback instanceof Function) {
                callback(res.resultdata);
            }
        } else {
            console.log('CheckOutres-success', res);
            alertvue(res.message);
        }
    }).catch((res) => {
        alertvue(res.message || res);
    });
}
//let printwindowname = "printwindowname"
//const PrintPage = () => {
//    const { href } = $router.resolve({
//        name: 'print',
//        params: { orderid: (props.orderHeader.orderno.length > 8 ? "checkout" : props.orderHeader.orderid), orderno: props.orderHeader.orderno }
//    });
//    window.open(href, printwindowname);

//}
export function ExportPdf_old(el, filename) {
    var element = document.getElementById(el);

    // Generate the PDF.
    html2pdf().from(element).set({
        // margin: 0,
        // pagebreak: { mode: 'avoid-all', before: ['img'] },
        pagebreak: { avoid: ['img', '.avoid-break'] },
        filename: filename + '.pdf',
        html2canvas: {
            scale: 2,
            dpi: 300,
        },
        jsPDF: {
            page_size: "A4",
            orientation: "landscape",
        }
    }).save();

}

export function ExportPdf_New(el, filename,optmargin) {
    var element = document.getElementById(el);
    forceDOMRendering();
    const pdfStyle = document.createElement('style');
      pdfStyle.innerHTML = `
      .notes-table {
          width: 100% !important;
          table-layout: fixed !important;
      }
      .notes-cell {
          width: 25% !important;
          min-width: 25% !important;
          max-width: 25% !important;
      }
  `;
  document.head.appendChild(pdfStyle);

  const opt = {
    pagebreak: { avoid: ['img', '.avoid-break'] },
        filename: `${filename}.pdf`,
        margin:[3,0,3,0],
        html2canvas: {
            scale: 3,
            logging: false,
            useCORS: false, 
            // 专门针对纯文本优化的设置
            ignoreElements: (element) => element.tagName === 'SCRIPT',
          },
        jsPDF: {
            page_size: "A4",
            orientation: "landscape",
        },
        pagebreak: {
        //   mode: 'avoid-all',
          avoid: ['tr', 'td']
        }
  }
    html2pdf().from(element).set(opt).toPdf().get('pdf').then(function(pdf) {
        document.head.removeChild(pdfStyle);
        var totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            pdf.setFontSize(12)
            pdf.setTextColor(0,0,0);
            pdf.setPage(i);
            pdf.text(`Page ${i} / ${totalPages}`, 10, pdf.internal.pageSize.getHeight() - 4);
        }
    }).save();

}

export function ExportPdf_MidRail(el, filename) {
    const element = document.getElementById(el);
    if (!element) {
      console.error(`Export element not found: #${el}`);
      return;
    }
    
 
    element.style.display = 'block';
    element.style.opacity = '1';
    element.style.visibility = 'visible';
    
    const opt = {
      filename: `${filename}.pdf`,
      margin: [5,5,5,5],
      html2canvas: {
        scale: 3,
        useCORS: true,
        logging: true,
        allowTaint: true,
        windowWidth: element.offsetWidth+40, 
        windowHeight: element.offsetHeight + 100, 
        scrollX: 0, 
        scrollY: 0, 
        onclone: (clonedDoc) => {
          // 确保克隆体中元素可见
          const cloneContainer = clonedDoc.getElementById(el);
          if (cloneContainer) {
            cloneContainer.style.display = 'block';
            cloneContainer.style.opacity = '1';
          }
        }
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'landscape'
      },
      pagebreak: { 
        mode: 'avoid-all',
        avoid: ['tr', 'td']
      }
    };
    
    
    html2pdf().set(opt).from(element).toPdf().get('pdf').then(pdf => {
  
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(`Page ${i}/${totalPages}`, 
          pdf.internal.pageSize.getWidth() - 30, 
          pdf.internal.pageSize.getHeight() - 10
        );
      }
    }).save();
  }
// export function ExportPdf(el, filename,optmargin) {
//     const element = document.getElementById(el);
//     const opt = {
//         margin: optmargin,
//         filename: filename + '.pdf',
//         html2canvas: {
//             scale: 2,
//             logging: true,
//             allowTaint: true
//         },
//         jsPDF: {
//             unit: 'mm',
//             format: [297, 210],
//             orientation: 'landscape',
//         },
//         pagebreak: {
//             mode: 'avoid-all',
//             avoid: ['tr', 'td', 'th']
//         }
//     };

//     html2pdf().set(opt).from(element).save();
// }
export function ExportPdf(el, filename, optmargin) {

    
    setTimeout(() => {
      const element = document.getElementById(el);
      

      forceDOMRendering();
      const pdfStyle = document.createElement('style');
      pdfStyle.innerHTML = `
      .notes-table {
          width: 100% !important;
          table-layout: fixed !important;
      }
      .notes-cell {
          width: 25% !important;
          min-width: 25% !important;
          max-width: 25% !important;
      }
  `;
  document.head.appendChild(pdfStyle);
      const opt = {
        margin: optmargin || 5,
        filename: `${filename}.pdf`,
        html2canvas: {
          scale: 1,
          logging: false,
          useCORS: false, 
          // 专门针对纯文本优化的设置
          ignoreElements: (element) => element.tagName === 'SCRIPT',
        },
        jsPDF: {
          unit: 'mm',
          format: [297, 210],
          orientation: 'landscape',
        },
        pagebreak: {
          mode: 'avoid-all',
          avoid: ['tr', 'td', 'th']
        }
      };
  
    //   html2pdf()
    //     .set(opt)
    //     .from(element)
    //     .save()
    //     .then(() => {
    //         document.head.removeChild(pdfStyle);
    //     })
    //     .catch(error => {
    //       console.error('PDF生成错误:', error);
   
    //     });
    // }, 1500);

    html2pdf().from(element).set(opt).toPdf().get('pdf').then(function(pdf) {
        document.head.removeChild(pdfStyle);
        var totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            pdf.setFontSize(12)
            pdf.setTextColor(0,0,0);
            pdf.setPage(i);
            pdf.text(`Page ${i} / ${totalPages}`, 10, pdf.internal.pageSize.getHeight() - 4);
        }
    }).save();
    }, 1500);
  }

export function forceDOMRendering() {

    const tables = document.querySelectorAll('table');
    tables.forEach(table => {

      table.offsetHeight;
      

      const rows = table.querySelectorAll('tr');
      rows.forEach(row => {
        row.offsetHeight;
        
        const cells = row.querySelectorAll('td, th');
        cells.forEach(cell => {
          cell.offsetHeight;
        });
      });
    });
  }

export function formatCurrency(num){
    if (num === null || num === undefined) return ''
    // 处理字符串类型输入
    const number = typeof num === 'string' ? parseFloat(num) : num
    // 校验数字有效性
    if (isNaN(number)) return num
    // 拆分整数和小数部分
    const parts = number.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    // 处理小数位（保留2位）
    const decimalPart = parts[1] ? parts[1].padEnd(2, '0').slice(0, 2) : '00'
    return parts[0] + (decimalPart ? `.${decimalPart}` : '')
}

export function formatDate(value) {
    if(value!=undefined && value!="")
    {
        value = value.replace(/[\u4e00-\u9fa5]/g, '');
    }
    if(value!=""&&value!=undefined)
    {
        var date = new Date(value);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return  day +"-"+ month +"-"+year;
    }
    else
    {
        return "";
    }
}

export function getdtatuslist(itemvalue){
    var res=[];
    var b2bshow = (Session.get("DEF")=="" && Session.get("CUT")=="B2B")||Session.get("DEF")=="*"||Session.get("DEF")=="D";
    if(b2bshow)
    {
        res.push({ id: "QUERY", value: "QUERY",disabled:false});
        res.push({ id: "SEND QUOTE", value: "SEND QUOTE" ,disabled:false});
        res.push({ id: "QUOTE SENT", value: "QUOTE SENT" ,disabled:false});
        res.push({ id: "DEPOSIT PAID", value: "DEPOSIT PAID" ,disabled:false});
        res.push({ id: "ON HOLD", value: "ON HOLD",disabled:false});
        res.push({ id: "ARCHIVE", value: "ARCHIVE" ,disabled:false});
    }
    else
    {
        //res.push({ id: "DRAFT", value: "DRAFT",disabled:false  });
        res.push({ id: "SEND QT", value: "SEND QT",disabled:false });
        //res.push({ id: "SEND REV QT", value: "SEND REV QT" ,disabled:false});
        //res.push({ id: "NEW SF SEND QT", value: "NEW SF SEND QT" ,disabled:false});
        //res.push({ id: "NEW SF HOLD QT", value: "NEW SF HOLD QT" ,disabled:false});
        //res.push({ id: "NEW SF HOLD ORDER", value: "NEW SF HOLD ORDER" ,disabled:false});
        //res.push({ id: "CHECK QT", value: "CHECK QT" ,disabled:false});
        //res.push({ id: "SEND ACC QT", value: "SEND ACC QT" ,disabled:false});
        res.push({ id: "ARCHIVE", value: "ARCHIVE" ,disabled:false});
        //res.push({ id: "HOLD ORDER", value: "HOLD ORDER" ,disabled:false});
        //res.push({ id: "LEAD", value: "LEAD" ,disabled:false});
        res.push({ id: "NZ Quote Check", value: "NZ Quote Check" ,disabled:false});
        //res.push({ id: "QT SENT", value: "QT SENT" ,disabled:false});
        //res.push({ id: "REP TO REV QT", value: "REP TO REV QT",disabled:false });
        //res.push({ id: "ACC RCVD", value: "ACC RCVD",disabled:false });
        //res.push({ id: "DEP RCVD", value: "DEP RCVD" ,disabled:false});
        //res.push({ id: "NZ Quote Check", value: "NZ Quote Check",disabled:false });
        if(!(Session.get("DEF")=="" && Session.get("CUT")=="B2C"))
        {
            res.push({ id: "SF CS CHECKING", value: "SF CS CHECKING",disabled:false });
            res.push({ id: "ORDER SUBMITTED", value: "ORDER SUBMITTED" ,disabled:false});
        }
        //res.push({ id: "Q ANSWERED", value: "Q ANSWERED" ,disabled:false});
        //res.push({ id: "FINAL NZ CHECK", value: "FINAL NZ CHECK" ,disabled:false});
        res.push({ id: "SERVICE ORDER", value: "SERVICE ORDER" ,disabled:false});
    }

    if(typeof(itemvalue)!="undefined"&&itemvalue!=''&& !res.filter(p=>p.value==itemvalue).length>0)
    {
        res.push({ id: itemvalue, value: itemvalue,disabled:true});
    }
    return res;
}